<template>
    <VueMultiselect
        v-model="value"
        :options="options"
        :placeholder="placeholder"
        :disabled="disabled"
        :closeOnSelect="closeOnSelect"
        :clearOnSelect="clearOnSelect"
        :showLabels="showLabels"
        :searchable="searchable"
        :allowEmpty="allowEmpty"
        :maxHeight="maxHeight"
        :multiple="multiple"
        :taggable="taggable"
        :trackBy="trackBy"
        :label="label"
        v-bind="$attrs"
        @open="$emit('open', $event)"
        @close="$emit('close', $event)"
    >
        <slot></slot>
    </VueMultiselect>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: [String, Object],
            default: '',
        },
        options: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        closeOnSelect: {
            type: Boolean,
            default: false,
        },
        clearOnSelect: {
            type: Boolean,
            default: false,
        },
        showLabels: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
        allowEmpty: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        taggable: {
            type: Boolean,
            default: false,
        },
        maxHeight: {
            type: Number,
            default: 200,
        },
        trackBy: {
            type: String,
            default: 'id',
        },
        label: {
            type: String,
            default: 'name',
        },
    },
    computed: {
        value: {
            get() {
                return this.$attrs.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
};
</script>
